import { z } from "zod";

import { PERIOD_PRESETS } from "./PERIOD_PRESETS";

const isoDaySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

// Фильтры списка матчей в search params главной: `/?mode=ranked&result=loss&heroes=[1,7]`.
// Нет параметра — фильтр выключен. Свой период — `from` и `to` (`to` не задан — один день),
// он важнее `period`. Неверное значение просто пропадает.
export const matchFiltersSchema = z.object({
  mode: z.enum(["ranked", "unranked"]).optional().catch(undefined),
  result: z.enum(["win", "loss"]).optional().catch(undefined),
  heroes: z.array(z.number().int().positive()).optional().catch(undefined),
  period: z.enum(PERIOD_PRESETS).optional().catch(undefined),
  from: isoDaySchema.optional().catch(undefined),
  to: isoDaySchema.optional().catch(undefined),
  analyzed: z.enum(["yes", "no"]).optional().catch(undefined),
  duration: z.enum(["short", "mid", "long"]).optional().catch(undefined),
  deaths: z.enum(["many"]).optional().catch(undefined),
  // Место в матче по оценке Valve: MVP или в тройке лучших.
  place: z.enum(["mvp", "top"]).optional().catch(undefined),
});

export type MatchFilters = z.infer<typeof matchFiltersSchema>;
